import { Grid2, Container } from "@mui/material";
import StatusIcon from "./StatusIcon.js";
import HeaderBar from "../Shared/HeaderBar/HeaderBar.js";
import NavigationBar from "../Shared/NavigationBar/NavigationBar.js"
import DashboardTile from "./DashboardTile.js";

export default function DashboardPage() {
	const status = Math.random() < 0.5 ? "alert" : "none";
	return (
		<>
			<HeaderBar></HeaderBar>
			<Container
				maxWidth="lg"
				sx={{
					alignItems:"center",
					justifyContent:"center",
					px: 2,
					mt: { xs: 0, sm: 0, md: 15 },
					pb: { xs: 0, sm: 0, md: 15 },
				}}>
				<Grid2
					container
					spacing={4}
					sx={{
						alignItems:"center",
						justifyContent:"center",
						mt: { xs: 0, sm: 0, md: 10 },
						pt: { xs: 6, sm: 15, md: 10 },
						pb: { xs: 10, sm: 0, md: 10 },
						maxWidth: '1100px',
						minWidth: 0,
						mx: 'auto',
						px: 6,
					}}
				>
					<Grid2 xs={12} sm={6} md={4}>
						<DashboardTile label="BA Status" icon={<StatusIcon status={status} />} />
					</Grid2>

					<Grid2 xs={12} sm={6} md={4}>
						<DashboardTile label="Total 3.0" value="10,677" />
					</Grid2>

					<Grid2 xs={12} sm={6} md={4}>
						<DashboardTile label="Total 1.0" value="4,212" />
					</Grid2>

					<Grid2 xs={12} sm={6} md={4}>
						<DashboardTile label="3.0 BA Penetration" value="8,213" />
					</Grid2>

					<Grid2 xs={12} sm={6} md={4}>
						<DashboardTile label="1.0 BA Penetration" value="3,512" />
					</Grid2>

					<Grid2 xs={12} sm={6} md={4}>
						<DashboardTile label="Top 3 Markets" 
									   value="WSYX - Columbus, OH" 
									   value2 ="KOMO - Seattle, WA" 
									   value3="KSNV - Las Vegas, NV" 
									   valueFontSize="23px" />
					</Grid2>

				</Grid2>
			</Container>

			<br /><br /><br />
			<NavigationBar></NavigationBar>
		</>
	);
}
